import React from 'react';
import {Suggestions} from 'components';

export function PositiveBeliefs(props) {
  return (
    <Suggestions.List {...props}>
      <p>I can be successful</p>
      <p>I am smart</p>
      <p>I can make it</p>
      <p>The universe supports me</p>
      <p>I can rely on my friends</p>
      <p>My family will always be there for me</p>
      <p>I am determined to succeed</p>
      <p>Life is great</p>
      <p>I can overcome the challenges</p>
      <p>Life is full of possibilities</p>
    </Suggestions.List>
  );
}
